import { useMemo } from "react";
import { useMediaQuery, useTheme } from "@mui/material";
import { Customer } from "../../store/services/customerService";
import CustomerProfileDesktop from "./CustomerProfileDesktop";
import CustomerProfileMobile from "./CustomerProfileMobile";

interface CustomerProfileProps {
  customer: Customer;
}

const CustomerProfile = ({ customer }: CustomerProfileProps) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  
  const isCompany = useMemo(
    () =>
      customer.LegalEntityType.find((x) => x.Selected)
        ?.LegalEntityTypeCustomerGroup === "F",
    [customer]
  );
  
  if (!customer) return null;
  
  // Render different layouts based on screen size
  return isMobile ? (
    <CustomerProfileMobile 
      customer={customer} 
      isCompany={isCompany} 
    />
  ) : (
    <CustomerProfileDesktop 
      customer={customer} 
      isCompany={isCompany} 
    />
  );
};

export default CustomerProfile;